import React, {useState} from "react";
import {Button, Col} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {useObserver} from "mobx-react-lite";
import CreateRequestModal from "../modals/createRequestModal/CreateRequestModal";

const ActionButtons = ({recall}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleOpenModal = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    return useObserver(() => (
        <>
            <Col>
                <Button type="primary" icon={<PlusOutlined />} onClick={handleOpenModal}>
                    Yeni Talep
                </Button>
            </Col>
            <CreateRequestModal
                visible={isModalVisible}
                onClose={handleCloseModal}
                recall={recall}
            />
        </>
    ));
};

export default ActionButtons;
